<ion-list>
  <ion-item>
    <ion-label position="stacked">
      What is your Academic Status?*
    </ion-label>

    <ion-button (click)="tooltip16.toggle()"  #tooltip16="matTooltip"  matTooltip slot="end" matTooltipShowDelay="1"   matTooltip="Some rotations are open to either students, graduates, or both. You can change this when you enter medical school or graduate."
    matTooltipPosition="above"  fill="clear"> <ion-icon color="medium" position="end" name="information-circle-outline" slot="icon-only"></ion-icon></ion-button>

    <div class="select-container">
      <ion-select (ionChange)="academicStatusChange($event)" value="{{profileData?.status}}" okText="Ok" cancelText="Dismiss">
        <ion-select-option [value]="'Student'">Student</ion-select-option>
        <ion-select-option [value]="'Graduate'">Graduate</ion-select-option>
        <ion-select-option [value]="'Pre-Med'">Pre-Med (US Only)</ion-select-option>
      </ion-select>
    </div>

  </ion-item>

  <ion-item>
    <ion-label position="stacked">Where did you attend University?
    </ion-label>

    <ion-button (click)="tooltip16.toggle()" #tooltip16="matTooltip" matTooltip slot="end" matTooltipShowDelay="1"  matTooltip="Select the country where your university is located."
    matTooltipPosition="above"  fill="clear"> <ion-icon color="medium" position="end" name="information-circle-outline" slot="icon-only"></ion-icon></ion-button>

    <div class="select-container">
      <ion-select value={{selectedCountry}}  [disabled]="disableCountrySelection" id="university-picker-country-select" (ionChange)="countryChange($event)" [interfaceOptions]="customCountryAlertOptions" interface="alert"
        placeholder="Select University Country">
        <ion-select-option *ngIf="selectedCountry"  value="{{selectedCountry}}">{{selectedCountry}}</ion-select-option>
        <ion-select-option *ngFor="let country of countries; let i=index; trackBy: trackByIndex;" value="{{country}}">
          {{country}}</ion-select-option>
      </ion-select>
    </div>

  </ion-item>  

  <ion-item >
    <ion-label position="stacked">Select University*
      <ion-note *ngIf="profileForm.get('university').hasError('required') && profileForm.get('university').touched" slot="end" color="danger">
        Required
      </ion-note>
    </ion-label>

    <ion-button (click)="tooltip16.toggle()" #tooltip16="matTooltip" matTooltip slot="end" matTooltipShowDelay="1"  matTooltip="Selecting your university helps us increase rotation options at your school."
    matTooltipPosition="above"  fill="clear"> <ion-icon color="medium" position="end" name="information-circle-outline" slot="icon-only"></ion-icon></ion-button>

    <div class="select-container">
      <ion-select value="{{schoolSelection}}" id="university-picker-select" [disabled]="disableSchoolSelection" (ionChange)="schoolChange($event)"
      [interfaceOptions]="customSchoolAlertOptions" interface="alert" placeholder="Select University">
        <ion-select-option *ngIf="schoolSelection"  value="{{schoolSelection}}">{{schoolSelection}}</ion-select-option>
        <ion-select-option *ngFor="let school of schools;" value="{{school.schoolname}}">{{school.schoolname}}</ion-select-option>
      </ion-select>
    </div>

  </ion-item>
</ion-list>